// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stock-adj-container {
  width: 100%;
  height: calc(100vh - 60px);
  margin-top: 60px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f8fafc; /* bg-slate-50 */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Sticky Header */
.stock-adj-header {
  background-color: #ffffff;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  position: sticky;
  top: 0;
  z-index: 10;
  width: 100%;
  flex-shrink: 0;
}

.stock-adj-header-content {
  max-width: 95%;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 4rem; /* h-16 */
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width:80%;
}

@media (min-width: 1200px) {
  .stock-adj-header-content,
  .stock-adj-body {
    max-width: 80% !important;
  }
}

.stock-adj-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.stock-adj-back-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #45556c;
}

.stock-adj-back-btn:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}

.stock-adj-title {
  font-size: 1.25rem; /* text-xl */
  font-weight: 700; /* font-bold */
  color: #0f172a; /* text-slate-900 */
  margin: 0;
}

/* Primary blue button "+ New Adjustment" */
.stock-adj-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 13px;
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
  border: 1px solid #2563eb;
  height: 2.25rem; /* min-h-9 */
  padding: 0 1rem; /* px-4 */
  background-color: #2563eb; /* bg-primary */
  color: #ffffff;
  gap: 0.5rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.stock-adj-btn-primary:hover {
  background-color: #1d4ed8;
}

.stock-adj-btn-primary svg {
  width: 1rem;
  height: 1rem;
}

/* Page Body */
.stock-adj-body {
  max-width: 95%;
  margin: 0 auto;
  padding: 2rem 1.5rem 5rem 1.5rem; /* px-6 py-8 */
  width: 80%;
  box-sizing: border-box;
  flex: 1;
}

/* Controls: Search + Filter */
.stock-adj-controls-row {
  display: flex;
  gap: 1rem; /* gap-4 */
  margin-bottom: 1.5rem; /* mb-6 */
  width: 100%;
}

.stock-adj-search-wrapper {
  position: relative;
  flex: 1;
}

.stock-adj-search-icon {
  position: absolute;
  left: 0.75rem; /* left-3 */
  top: 50%;
  transform: translateY(-50%);
  width: 1rem; /* w-4 */
  height: 1rem; /* h-4 */
  color: #94a3b8; /* text-slate-400 */
  pointer-events: none;
}

.stock-adj-search-input {
  display: flex;
  height: 2.25rem; /* h-9 */
  width: 100%;
  border-radius: 13px;
  border: 1px solid #cbd5e1; /* border-input */
  padding: 0.25rem 0.75rem 0.25rem 2.25rem; /* pl-9 */
  font-size: 0.875rem; /* text-sm */
  color: #0f172a;
  background-color: #ffffff;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  outline: none;
  box-sizing: border-box;
}

.stock-adj-search-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}

.stock-adj-search-input::placeholder {
  color: #94a3b8;
}

/* Filter button */
.stock-adj-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 13px; /* rounded-md */
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
  border: 1px solid #cbd5e1;
  height: 2.25rem; /* min-h-9 */
  padding: 0 1rem; /* px-4 */
  background-color: #ffffff;
  color: #0f172a;
  gap: 0.5rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.stock-adj-btn-secondary:hover {
  background-color: #f8fafc;
}

.stock-adj-btn-secondary svg {
  width: 1rem;
  height: 1rem;
  color: #64748b;
}

/* Active filters display */
.stock-adj-active-filters {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 1.5rem;
}

.stock-adj-active-filters-label {
  color: #64748b;
  font-size: 0.8125rem;
}

/* Table Card */
.stock-adj-table-card {
  background-color: #ffffff;
  border-radius: 1rem; /* rounded-2xl */
  border: 1px solid #e2e8f0; /* border-slate-100 */
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px -1px rgba(0, 0, 0, 0.05); /* shadow-sm */
  overflow: hidden;
  width: 100%;
}

.stock-adj-table-wrapper {
  overflow-x: auto;
  width: 100%;
}

/* Reset borders explicitly to override any global CSS styles */
.stock-adj-table-card .stock-adj-table,
.stock-adj-table-card .stock-adj-table th,
.stock-adj-table-card .stock-adj-table td,
.stock-adj-table-card .stock-adj-row {
  border: none !important;
}

.stock-adj-table {
  width: 100%;
  border-collapse: collapse !important;
  text-align: left;
  font-size: 0.875rem; /* text-sm */
}

.stock-adj-table-card .stock-adj-table th {
  background-color: #f8fafc !important; /* bg-slate-50 */
  border-bottom: 1px solid #e2e8f0 !important; /* border-slate-100 */
  padding: 1rem !important; /* p-4 */
  font-weight: 600 !important; /* font-semibold */
  color: #475569 !important; /* text-slate-700 */
  white-space: nowrap;
  text-align: center !important;
}

.stock-adj-table th:first-child {
  text-align: left !important;
}

.stock-adj-row {
  border-bottom: 1px solid #e2e8f0 !important; /* divide-y divide-slate-100 */
  transition: background-color 0.15s ease;
  cursor: pointer;
}

.stock-adj-row:hover {
  background-color: #f8fafc; /* hover:bg-slate-50 */
}

.stock-adj-row td {
  padding: 1rem !important; /* p-4 */
  vertical-align: middle !important;
  text-align: center !important;
}

.stock-adj-row td:first-child {
  text-align: left !important;
}

.stock-adj-cell-date {
  color: #64748b !important; /* text-slate-500 */
  white-space: nowrap;
}

.stock-adj-cell-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
}

.stock-adj-item-date {
  color: #78797b; 
}

.stock-adj-item-name {
  font-weight: 500; /* font-medium */
  color: #0f172a; /* text-slate-900 */
}

.stock-adj-item-sku {
  font-size: 0.75rem; /* text-xs */
  color: #94a3b8; /* text-slate-400 */
}

.stock-adj-cell-qty {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace; /* font-mono */
  font-weight: 500; /* font-medium */
}

.qty-negative {
  color: #e11d48 !important; /* text-rose-600 */
}

.qty-positive {
  color: #10b981 !important; /* text-emerald-600 */
}

.stock-adj-cell-reason {
  color: #475569; /* text-slate-600 */
  max-width: 16rem; /* max-w-xs */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stock-adj-cell-auth {
  color: #64748b; /* text-slate-500 */
}

/* Badge Tags: WASTAGE, BROKEN, CORRECTION ADD */
.tag-common {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem; /* px-2 py-1 */
  border-radius: 0.375rem; /* rounded-md */
  font-size: 0.75rem; /* text-xs */
  font-weight: 500; /* font-medium */
  border-width: 1px;
  border-style: solid;
}

.tag-wastage {
  background-color: #fffbeb !important; /* bg-amber-50 */
  color: #b45309 !important; /* text-amber-700 */
  border-color: #fde68a !important; /* border-amber-100 */
}

.tag-broken {
  background-color: #fff1f2 !important; /* bg-rose-50 */
  color: #be123c !important; /* text-rose-700 */
  border-color: #fecdd3 !important; /* border-rose-100 */
}

.tag-correction-add {
  background-color: #ecfdf5 !important; /* bg-emerald-50 */
  color: #047857 !important; /* text-emerald-700 */
  border-color: #a7f3d0 !important; /* border-emerald-100 */
}

/* Pagination Footer */
.stock-adj-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  background-color: #ffffff;
}

.stock-adj-pagination-info {
  font-size: 0.875rem;
  color: #64748b;
}

.stock-adj-pagination-btns {
  display: flex;
  gap: 0.5rem;
}

.stock-adj-pagination-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  color: #334155;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.stock-adj-pagination-btn:hover:not(:disabled) {
  background-color: #f8fafc;
}

.stock-adj-pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Spinner and Empty States */
.stock-adj-loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  background-color: #ffffff;
}

.stock-adj-empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #64748b;
  font-size: 0.875rem;
  width: 100%;
  background-color: #ffffff;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
}

/* ==========================================================================
   Adjustment Creation Modal Revamp Styles
   ========================================================================== */

.adj-modal-container {
  width: 1200px;
  max-width: 90vw;
  height: 100vh;
  background-color: #ffffff;
  padding: 1.5rem;
  box-sizing: border-box;
  outline: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.adj-modal-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.adj-modal-content::-webkit-scrollbar {
  width: 6px;
}

.adj-modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.adj-modal-content::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 3px;
}

.adj-modal-content::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}

.adj-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-shrink: 0;
}

.adj-modal-title {
  font-size: 1.125rem; /* text-lg */
  font-weight: 600; /* font-semibold */
  color: #0f172a;
  margin: 0;
}

.adj-modal-close-btn {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.adj-modal-close-btn:hover {
  color: #475569;
}

.adj-modal-close-btn svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* Grid systems */
.adj-form-grid {
  display: grid;
  gap: 1rem;
  margin-bottom: 1rem;
}

.adj-field-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.adj-field-label {
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  color: #334155; /* text-slate-700 */
  margin: 0;
}

.adj-field-input {
  display: flex;
  height: 2.25rem; /* h-9 */
  width: 100%;
  border-radius: 13px; /* rounded-md */
  border: 1px solid #cbd5e1; /* border-input */
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem; /* text-sm */
  color: #0f172a;
  background-color: #ffffff;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  outline: none;
  box-sizing: border-box;
}

.adj-field-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}

.adj-field-input::placeholder {
  color: #94a3b8;
}

.adj-field-input:disabled {
  background-color: #f8fafc !important; /* bg-slate-50 */
  color: #64748b;
  cursor: not-allowed;
  border-color: #cbd5e1 !important;
}

.adj-field-textarea {
  display: flex;
  min-height: 4.5rem; /* min-h-[72px] */
  width: 100%;
  border-radius: 0.375rem; /* rounded-md */
  border: 1px solid #cbd5e1; /* border-input */
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem; /* text-sm */
  color: #0f172a;
  background-color: #ffffff;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  outline: none;
  box-sizing: border-box;
  resize: vertical;
}

.adj-field-textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
}

.adj-field-textarea::placeholder {
  color: #94a3b8;
}

/* Autocomplete override for search field */
.adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-root {
  height: 36px !important;
  border-radius: 13px;
  font-size: 13px;
  padding: 0 9px !important;
  background-color: #ffffff !important;
  border: 1px solid #cbd5e1 !important;
}

.adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-notchedOutline {
  border: none !important;
}

.adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-root:focus-within {
  border-color: #2563eb !important;
  box-shadow: 0 0 0 1px #2563eb !important;
}

/* Adjustments mapping */
.adj-adjustment-item-card {
  background-color: #ffffff;
  /* border: 1px solid #e2e8f0; */
  /* border-radius: 0.5rem; */
  padding: 1rem;
  margin-bottom: 1rem;
  position: relative;
}

.adj-adjustment-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 0.75rem;
  grid-column: 1 / -1;
}

.adj-btn-remove {
  background: none;
  border: none;
  color: #ef4444; /* red-500 */
  font-size: 0.8125rem;
  cursor: pointer;
  font-weight: 500;
}

.adj-btn-remove:hover {
  color: #dc2626;
}

/* Footer & Buttons */
.adj-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem; /* gap-2 */
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  flex-shrink: 0;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.adj-btn-cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 13px; /* rounded-md */
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  transition: background-color 0.15s ease;
  border: 1px solid #cbd5e1;
  height: 2.25rem; /* min-h-9 */
  padding: 0 1rem; /* px-4 */
  background-color: #ffffff;
  color: #334155;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.adj-btn-cancel:hover {
  background-color: #f8fafc;
}

.adj-btn-save {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 13px; /* rounded-md */
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  transition: background-color 0.15s ease;
  border: 1px solid #2563eb;
  height: 2.25rem; /* min-h-9 */
  padding: 0 1rem; /* px-4 */
  background-color: #2563eb;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.adj-btn-save:hover {
  background-color: #1d4ed8;
}

.adj-btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #cbd5e1;
  border-color: #cbd5e1;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .adj-modal-container {
    width: 100vw;
    max-width: 100vw;
    padding: 1rem;
  }

  .adj-modal-content .grid {
    grid-template-columns: 1fr !important;
  }

  .adj-adjustment-item-card {
    grid-template-columns: 1fr !important;
  }

  .adj-modal-footer {
    flex-direction: column;
  }

  .adj-modal-footer button {
    width: 100%;
  }
}

/* ═══════════════════════════════════════════
   DARK THEME — Stock Adjustment
   ═══════════════════════════════════════════ */

.dark .stock-adj-container {
  background-color: #0f172a;
}

.dark .stock-adj-header {
  background-color: #1e293b;
  border-bottom-color: #334155;
}

.dark .stock-adj-back-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .stock-adj-back-btn:hover {
  background-color: #334155;
  color: #f1f5f9;
}

.dark .stock-adj-title {
  color: #f1f5f9;
}

/* Search input */
.dark .stock-adj-search-input {
  background-color: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}
.dark .stock-adj-search-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}
.dark .stock-adj-search-input::placeholder { color: #475569; }

/* Filter button */
.dark .stock-adj-btn-secondary {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .stock-adj-btn-secondary:hover { background-color: #334155; }
.dark .stock-adj-btn-secondary svg { color: #94a3b8; }

/* Active filter label */
.dark .stock-adj-active-filters-label { color: #94a3b8; }

/* Table card */
.dark .stock-adj-table-card {
  background-color: #1e293b;
  border-color: #334155;
}

/* Table header */
.dark .stock-adj-table-card .stock-adj-table th {
  background-color: #0f172a !important;
  border-bottom-color: #334155 !important;
  color: #94a3b8 !important;
}

/* Table rows */
.dark .stock-adj-row {
  border-bottom-color: #334155 !important;
}
.dark .stock-adj-row:hover { background-color: #243043; }

/* Cell colours */
.dark .stock-adj-cell-date { color: #94a3b8 !important; }
.dark .stock-adj-item-name { color: #e2e8f0; }
.dark .stock-adj-item-sku  { color: #64748b; }
.dark .stock-adj-cell-reason { color: #94a3b8; }
.dark .stock-adj-cell-auth  { color: #64748b; }
.dark .stock-adj-item-date  { color: #64748b; }

/* Dark-mode tags */
.dark .tag-wastage    { background-color: #451a03 !important; color: #fbbf24 !important; border-color: #78350f !important; }
.dark .tag-broken     { background-color: #4c0519 !important; color: #fca5a5 !important; border-color: #7f1d1d !important; }
.dark .tag-correction-add { background-color: #052e16 !important; color: #6ee7b7 !important; border-color: #14532d !important; }

/* Pagination */
.dark .stock-adj-pagination {
  background-color: #1e293b;
  border-top-color: #334155;
}
.dark .stock-adj-pagination-info { color: #94a3b8; }
.dark .stock-adj-pagination-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .stock-adj-pagination-btn:hover:not(:disabled) { background-color: #334155; }

/* Loader / Empty */
.dark .stock-adj-loader-container { background-color: #1e293b; }
.dark .stock-adj-empty-state {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

/* ── Adjustment Creation Modal ── */
.dark .adj-modal-container {
  background-color: #1e293b;
}

.dark .adj-modal-title { color: #f1f5f9; }
.dark .adj-modal-close-btn { color: #64748b; }
.dark .adj-modal-close-btn:hover { color: #94a3b8; }

.dark .adj-field-label { color: #94a3b8; }

.dark .adj-field-input,
.dark .adj-field-textarea {
  background-color: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}
.dark .adj-field-input:focus,
.dark .adj-field-textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}
.dark .adj-field-input::placeholder,
.dark .adj-field-textarea::placeholder { color: #475569; }
.dark .adj-field-input:disabled {
  background-color: #1e293b !important;
  color: #475569;
  border-color: #334155 !important;
}

/* MUI Autocomplete inside modal */
.dark .adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-root {
  background-color: #0f172a !important;
  border-color: #334155 !important;
}
.dark .adj-field-group .MuiInputBase-input { color: #f1f5f9 !important; }

.dark .adj-adjustment-item-card { background-color: #0f172a; }
.dark .adj-adjustment-item-header { color: #f1f5f9; }

.dark .adj-modal-footer {
  background-color: #1e293b;
  border-top-color: #334155;
}
.dark .adj-btn-cancel {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .adj-btn-cancel:hover { background-color: #334155; }

.dark .adj-modal-content {
  scrollbar-color: #334155 transparent;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/StockAdjustment/StockAdjustment.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB,EAAE,gBAAgB;EAC3C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,iDAAiD;EACjD,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,YAAY,EAAE,SAAS;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB,EAAE,YAAY;EAChC,gBAAgB,EAAE,cAAc;EAChC,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,gBAAgB;EAClC;;0BAEwB;EACxB,yBAAyB;EACzB,eAAe,EAAE,YAAY;EAC7B,eAAe,EAAE,SAAS;EAC1B,yBAAyB,EAAE,eAAe;EAC1C,cAAc;EACd,WAAW;EACX,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,cAAc;AACd;EACE,cAAc;EACd,cAAc;EACd,gCAAgC,EAAE,cAAc;EAChD,UAAU;EACV,sBAAsB;EACtB,OAAO;AACT;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS,EAAE,UAAU;EACrB,qBAAqB,EAAE,SAAS;EAChC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,WAAW;EAC1B,QAAQ;EACR,2BAA2B;EAC3B,WAAW,EAAE,QAAQ;EACrB,YAAY,EAAE,QAAQ;EACtB,cAAc,EAAE,mBAAmB;EACnC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,QAAQ;EACzB,WAAW;EACX,mBAAmB;EACnB,yBAAyB,EAAE,iBAAiB;EAC5C,wCAAwC,EAAE,SAAS;EACnD,mBAAmB,EAAE,YAAY;EACjC,cAAc;EACd,yBAAyB;EACzB;;yBAEuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB,EAAE,eAAe;EACpC,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,gBAAgB;EAClC;;0BAEwB;EACxB,yBAAyB;EACzB,eAAe,EAAE,YAAY;EAC7B,eAAe,EAAE,SAAS;EAC1B,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,mBAAmB,EAAE,gBAAgB;EACrC,yBAAyB,EAAE,qBAAqB;EAChD;;sCAEoC,EAAE,cAAc;EACpD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,+DAA+D;AAC/D;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB,EAAE,YAAY;AACnC;;AAEA;EACE,oCAAoC,EAAE,gBAAgB;EACtD,2CAA2C,EAAE,qBAAqB;EAClE,wBAAwB,EAAE,QAAQ;EAClC,2BAA2B,EAAE,kBAAkB;EAC/C,yBAAyB,EAAE,mBAAmB;EAC9C,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C,EAAE,8BAA8B;EAC3E,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,wBAAwB,EAAE,QAAQ;EAClC,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,kBAAkB,EAAE,YAAY;EAChC,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE;4BAC0B,EAAE,cAAc;EAC1C,gBAAgB,EAAE,gBAAgB;AACpC;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;AAC/C;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,gBAAgB,EAAE,aAAa;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB,EAAE,cAAc;EACvC,uBAAuB,EAAE,eAAe;EACxC,kBAAkB,EAAE,YAAY;EAChC,gBAAgB,EAAE,gBAAgB;EAClC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC,EAAE,gBAAgB;EACtD,yBAAyB,EAAE,mBAAmB;EAC9C,gCAAgC,EAAE,qBAAqB;AACzD;;AAEA;EACE,oCAAoC,EAAE,eAAe;EACrD,yBAAyB,EAAE,kBAAkB;EAC7C,gCAAgC,EAAE,oBAAoB;AACxD;;AAEA;EACE,oCAAoC,EAAE,kBAAkB;EACxD,yBAAyB,EAAE,qBAAqB;EAChD,gCAAgC,EAAE,uBAAuB;AAC3D;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,kBAAkB;EACpC,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe,EAAE,QAAQ;EACzB,WAAW;EACX,mBAAmB,EAAE,eAAe;EACpC,yBAAyB,EAAE,iBAAiB;EAC5C,yBAAyB;EACzB,mBAAmB,EAAE,YAAY;EACjC,cAAc;EACd,yBAAyB;EACzB;;yBAEuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC,EAAE,gBAAgB;EACtD,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB,EAAE,iBAAiB;EACrC,WAAW;EACX,uBAAuB,EAAE,eAAe;EACxC,yBAAyB,EAAE,iBAAiB;EAC5C,uBAAuB;EACvB,mBAAmB,EAAE,YAAY;EACjC,cAAc;EACd,yBAAyB;EACzB;;yBAEuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc,EAAE,YAAY;EAC5B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW,EAAE,UAAU;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB,EAAE,eAAe;EACpC,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,gBAAgB;EAClC,uCAAuC;EACvC,yBAAyB;EACzB,eAAe,EAAE,YAAY;EAC7B,eAAe,EAAE,SAAS;EAC1B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB,EAAE,eAAe;EACpC,mBAAmB,EAAE,YAAY;EACjC,gBAAgB,EAAE,gBAAgB;EAClC,uCAAuC;EACvC,yBAAyB;EACzB,eAAe,EAAE,YAAY;EAC7B,eAAe,EAAE,SAAS;EAC1B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;gDAEgD;;AAEhD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA,6CAA6C,cAAc,EAAE;;AAE7D,kBAAkB;AAClB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,uCAAuC,yBAAyB,EAAE;AAClE,qCAAqC,cAAc,EAAE;;AAErD,wBAAwB;AACxB,wCAAwC,cAAc,EAAE;;AAExD,eAAe;AACf;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,uCAAuC;AACzC;AACA,6BAA6B,yBAAyB,EAAE;;AAExD,iBAAiB;AACjB,6BAA6B,yBAAyB,EAAE;AACxD,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,+BAA+B,cAAc,EAAE;AAC/C,8BAA8B,cAAc,EAAE;AAC9C,8BAA8B,cAAc,EAAE;;AAE9C,mBAAmB;AACnB,wBAAwB,oCAAoC,EAAE,yBAAyB,EAAE,gCAAgC,EAAE;AAC3H,wBAAwB,oCAAoC,EAAE,yBAAyB,EAAE,gCAAgC,EAAE;AAC3H,4BAA4B,oCAAoC,EAAE,yBAAyB,EAAE,gCAAgC,EAAE;;AAE/H,eAAe;AACf;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA,mCAAmC,cAAc,EAAE;AACnD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,uDAAuD,yBAAyB,EAAE;;AAElF,mBAAmB;AACnB,oCAAoC,yBAAyB,EAAE;AAC/D;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB,cAAc,EAAE;AACzC,6BAA6B,cAAc,EAAE;AAC7C,mCAAmC,cAAc,EAAE;;AAEnD,yBAAyB,cAAc,EAAE;;AAEzC;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;yCACyC,cAAc,EAAE;AACzD;EACE,oCAAoC;EACpC,cAAc;EACd,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA,6CAA6C,yBAAyB,EAAE;;AAExE,kCAAkC,yBAAyB,EAAE;AAC7D,oCAAoC,cAAc,EAAE;;AAEpD;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,8BAA8B,yBAAyB,EAAE;;AAEzD;EACE,oCAAoC;AACtC","sourcesContent":[".stock-adj-container {\n  width: 100%;\n  height: calc(100vh - 60px);\n  margin-top: 60px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #f8fafc; /* bg-slate-50 */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Sticky Header */\n.stock-adj-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.stock-adj-header-content {\n  max-width: 95%;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  height: 4rem; /* h-16 */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  width:80%;\n}\n\n@media (min-width: 1200px) {\n  .stock-adj-header-content,\n  .stock-adj-body {\n    max-width: 80% !important;\n  }\n}\n\n.stock-adj-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.stock-adj-back-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #45556c;\n}\n\n.stock-adj-back-btn:hover {\n  background-color: #e2e8f0;\n  color: #0f172a;\n}\n\n.stock-adj-title {\n  font-size: 1.25rem; /* text-xl */\n  font-weight: 700; /* font-bold */\n  color: #0f172a; /* text-slate-900 */\n  margin: 0;\n}\n\n/* Primary blue button \"+ New Adjustment\" */\n.stock-adj-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  border-radius: 13px;\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n  border: 1px solid #2563eb;\n  height: 2.25rem; /* min-h-9 */\n  padding: 0 1rem; /* px-4 */\n  background-color: #2563eb; /* bg-primary */\n  color: #ffffff;\n  gap: 0.5rem;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.stock-adj-btn-primary:hover {\n  background-color: #1d4ed8;\n}\n\n.stock-adj-btn-primary svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n/* Page Body */\n.stock-adj-body {\n  max-width: 95%;\n  margin: 0 auto;\n  padding: 2rem 1.5rem 5rem 1.5rem; /* px-6 py-8 */\n  width: 80%;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n/* Controls: Search + Filter */\n.stock-adj-controls-row {\n  display: flex;\n  gap: 1rem; /* gap-4 */\n  margin-bottom: 1.5rem; /* mb-6 */\n  width: 100%;\n}\n\n.stock-adj-search-wrapper {\n  position: relative;\n  flex: 1;\n}\n\n.stock-adj-search-icon {\n  position: absolute;\n  left: 0.75rem; /* left-3 */\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1rem; /* w-4 */\n  height: 1rem; /* h-4 */\n  color: #94a3b8; /* text-slate-400 */\n  pointer-events: none;\n}\n\n.stock-adj-search-input {\n  display: flex;\n  height: 2.25rem; /* h-9 */\n  width: 100%;\n  border-radius: 13px;\n  border: 1px solid #cbd5e1; /* border-input */\n  padding: 0.25rem 0.75rem 0.25rem 2.25rem; /* pl-9 */\n  font-size: 0.875rem; /* text-sm */\n  color: #0f172a;\n  background-color: #ffffff;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.stock-adj-search-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px #2563eb;\n}\n\n.stock-adj-search-input::placeholder {\n  color: #94a3b8;\n}\n\n/* Filter button */\n.stock-adj-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  border-radius: 13px; /* rounded-md */\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease;\n  border: 1px solid #cbd5e1;\n  height: 2.25rem; /* min-h-9 */\n  padding: 0 1rem; /* px-4 */\n  background-color: #ffffff;\n  color: #0f172a;\n  gap: 0.5rem;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.stock-adj-btn-secondary:hover {\n  background-color: #f8fafc;\n}\n\n.stock-adj-btn-secondary svg {\n  width: 1rem;\n  height: 1rem;\n  color: #64748b;\n}\n\n/* Active filters display */\n.stock-adj-active-filters {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.stock-adj-active-filters-label {\n  color: #64748b;\n  font-size: 0.8125rem;\n}\n\n/* Table Card */\n.stock-adj-table-card {\n  background-color: #ffffff;\n  border-radius: 1rem; /* rounded-2xl */\n  border: 1px solid #e2e8f0; /* border-slate-100 */\n  box-shadow:\n    0 1px 3px 0 rgba(0, 0, 0, 0.05),\n    0 1px 2px -1px rgba(0, 0, 0, 0.05); /* shadow-sm */\n  overflow: hidden;\n  width: 100%;\n}\n\n.stock-adj-table-wrapper {\n  overflow-x: auto;\n  width: 100%;\n}\n\n/* Reset borders explicitly to override any global CSS styles */\n.stock-adj-table-card .stock-adj-table,\n.stock-adj-table-card .stock-adj-table th,\n.stock-adj-table-card .stock-adj-table td,\n.stock-adj-table-card .stock-adj-row {\n  border: none !important;\n}\n\n.stock-adj-table {\n  width: 100%;\n  border-collapse: collapse !important;\n  text-align: left;\n  font-size: 0.875rem; /* text-sm */\n}\n\n.stock-adj-table-card .stock-adj-table th {\n  background-color: #f8fafc !important; /* bg-slate-50 */\n  border-bottom: 1px solid #e2e8f0 !important; /* border-slate-100 */\n  padding: 1rem !important; /* p-4 */\n  font-weight: 600 !important; /* font-semibold */\n  color: #475569 !important; /* text-slate-700 */\n  white-space: nowrap;\n  text-align: center !important;\n}\n\n.stock-adj-table th:first-child {\n  text-align: left !important;\n}\n\n.stock-adj-row {\n  border-bottom: 1px solid #e2e8f0 !important; /* divide-y divide-slate-100 */\n  transition: background-color 0.15s ease;\n  cursor: pointer;\n}\n\n.stock-adj-row:hover {\n  background-color: #f8fafc; /* hover:bg-slate-50 */\n}\n\n.stock-adj-row td {\n  padding: 1rem !important; /* p-4 */\n  vertical-align: middle !important;\n  text-align: center !important;\n}\n\n.stock-adj-row td:first-child {\n  text-align: left !important;\n}\n\n.stock-adj-cell-date {\n  color: #64748b !important; /* text-slate-500 */\n  white-space: nowrap;\n}\n\n.stock-adj-cell-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n}\n\n.stock-adj-item-date {\n  color: #78797b; \n}\n\n.stock-adj-item-name {\n  font-weight: 500; /* font-medium */\n  color: #0f172a; /* text-slate-900 */\n}\n\n.stock-adj-item-sku {\n  font-size: 0.75rem; /* text-xs */\n  color: #94a3b8; /* text-slate-400 */\n}\n\n.stock-adj-cell-qty {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n    \"Courier New\", monospace; /* font-mono */\n  font-weight: 500; /* font-medium */\n}\n\n.qty-negative {\n  color: #e11d48 !important; /* text-rose-600 */\n}\n\n.qty-positive {\n  color: #10b981 !important; /* text-emerald-600 */\n}\n\n.stock-adj-cell-reason {\n  color: #475569; /* text-slate-600 */\n  max-width: 16rem; /* max-w-xs */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.stock-adj-cell-auth {\n  color: #64748b; /* text-slate-500 */\n}\n\n/* Badge Tags: WASTAGE, BROKEN, CORRECTION ADD */\n.tag-common {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.5rem; /* px-2 py-1 */\n  border-radius: 0.375rem; /* rounded-md */\n  font-size: 0.75rem; /* text-xs */\n  font-weight: 500; /* font-medium */\n  border-width: 1px;\n  border-style: solid;\n}\n\n.tag-wastage {\n  background-color: #fffbeb !important; /* bg-amber-50 */\n  color: #b45309 !important; /* text-amber-700 */\n  border-color: #fde68a !important; /* border-amber-100 */\n}\n\n.tag-broken {\n  background-color: #fff1f2 !important; /* bg-rose-50 */\n  color: #be123c !important; /* text-rose-700 */\n  border-color: #fecdd3 !important; /* border-rose-100 */\n}\n\n.tag-correction-add {\n  background-color: #ecfdf5 !important; /* bg-emerald-50 */\n  color: #047857 !important; /* text-emerald-700 */\n  border-color: #a7f3d0 !important; /* border-emerald-100 */\n}\n\n/* Pagination Footer */\n.stock-adj-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e2e8f0;\n  background-color: #ffffff;\n}\n\n.stock-adj-pagination-info {\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n.stock-adj-pagination-btns {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.stock-adj-pagination-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.375rem;\n  border: 1px solid #cbd5e1;\n  background-color: #ffffff;\n  color: #334155;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.stock-adj-pagination-btn:hover:not(:disabled) {\n  background-color: #f8fafc;\n}\n\n.stock-adj-pagination-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Spinner and Empty States */\n.stock-adj-loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  width: 100%;\n  background-color: #ffffff;\n}\n\n.stock-adj-empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  color: #64748b;\n  font-size: 0.875rem;\n  width: 100%;\n  background-color: #ffffff;\n  border-radius: 1rem;\n  border: 1px solid #e2e8f0;\n}\n\n/* ==========================================================================\n   Adjustment Creation Modal Revamp Styles\n   ========================================================================== */\n\n.adj-modal-container {\n  width: 1200px;\n  max-width: 90vw;\n  height: 100vh;\n  background-color: #ffffff;\n  padding: 1.5rem;\n  box-sizing: border-box;\n  outline: none;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.adj-modal-content {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.adj-modal-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.adj-modal-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.adj-modal-content::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 3px;\n}\n\n.adj-modal-content::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8;\n}\n\n.adj-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-shrink: 0;\n}\n\n.adj-modal-title {\n  font-size: 1.125rem; /* text-lg */\n  font-weight: 600; /* font-semibold */\n  color: #0f172a;\n  margin: 0;\n}\n\n.adj-modal-close-btn {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  transition: color 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.adj-modal-close-btn:hover {\n  color: #475569;\n}\n\n.adj-modal-close-btn svg {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* Grid systems */\n.adj-form-grid {\n  display: grid;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.adj-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.adj-field-label {\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n  color: #334155; /* text-slate-700 */\n  margin: 0;\n}\n\n.adj-field-input {\n  display: flex;\n  height: 2.25rem; /* h-9 */\n  width: 100%;\n  border-radius: 13px; /* rounded-md */\n  border: 1px solid #cbd5e1; /* border-input */\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem; /* text-sm */\n  color: #0f172a;\n  background-color: #ffffff;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.adj-field-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px #2563eb;\n}\n\n.adj-field-input::placeholder {\n  color: #94a3b8;\n}\n\n.adj-field-input:disabled {\n  background-color: #f8fafc !important; /* bg-slate-50 */\n  color: #64748b;\n  cursor: not-allowed;\n  border-color: #cbd5e1 !important;\n}\n\n.adj-field-textarea {\n  display: flex;\n  min-height: 4.5rem; /* min-h-[72px] */\n  width: 100%;\n  border-radius: 0.375rem; /* rounded-md */\n  border: 1px solid #cbd5e1; /* border-input */\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem; /* text-sm */\n  color: #0f172a;\n  background-color: #ffffff;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n  outline: none;\n  box-sizing: border-box;\n  resize: vertical;\n}\n\n.adj-field-textarea:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 1px #2563eb;\n}\n\n.adj-field-textarea::placeholder {\n  color: #94a3b8;\n}\n\n/* Autocomplete override for search field */\n.adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-root {\n  height: 36px !important;\n  border-radius: 13px;\n  font-size: 13px;\n  padding: 0 9px !important;\n  background-color: #ffffff !important;\n  border: 1px solid #cbd5e1 !important;\n}\n\n.adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-notchedOutline {\n  border: none !important;\n}\n\n.adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-root:focus-within {\n  border-color: #2563eb !important;\n  box-shadow: 0 0 0 1px #2563eb !important;\n}\n\n/* Adjustments mapping */\n.adj-adjustment-item-card {\n  background-color: #ffffff;\n  /* border: 1px solid #e2e8f0; */\n  /* border-radius: 0.5rem; */\n  padding: 1rem;\n  margin-bottom: 1rem;\n  position: relative;\n}\n\n.adj-adjustment-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #0f172a;\n  margin-bottom: 0.75rem;\n  grid-column: 1 / -1;\n}\n\n.adj-btn-remove {\n  background: none;\n  border: none;\n  color: #ef4444; /* red-500 */\n  font-size: 0.8125rem;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.adj-btn-remove:hover {\n  color: #dc2626;\n}\n\n/* Footer & Buttons */\n.adj-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem; /* gap-2 */\n  padding-top: 1.5rem;\n  padding-bottom: 0.5rem;\n  flex-shrink: 0;\n  background-color: #ffffff;\n  border-top: 1px solid #e2e8f0;\n}\n\n.adj-btn-cancel {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  border-radius: 13px; /* rounded-md */\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n  transition: background-color 0.15s ease;\n  border: 1px solid #cbd5e1;\n  height: 2.25rem; /* min-h-9 */\n  padding: 0 1rem; /* px-4 */\n  background-color: #ffffff;\n  color: #334155;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.adj-btn-cancel:hover {\n  background-color: #f8fafc;\n}\n\n.adj-btn-save {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  border-radius: 13px; /* rounded-md */\n  font-size: 0.875rem; /* text-sm */\n  font-weight: 500; /* font-medium */\n  transition: background-color 0.15s ease;\n  border: 1px solid #2563eb;\n  height: 2.25rem; /* min-h-9 */\n  padding: 0 1rem; /* px-4 */\n  background-color: #2563eb;\n  color: #ffffff;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.adj-btn-save:hover {\n  background-color: #1d4ed8;\n}\n\n.adj-btn-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #cbd5e1;\n  border-color: #cbd5e1;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .adj-modal-container {\n    width: 100vw;\n    max-width: 100vw;\n    padding: 1rem;\n  }\n\n  .adj-modal-content .grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .adj-adjustment-item-card {\n    grid-template-columns: 1fr !important;\n  }\n\n  .adj-modal-footer {\n    flex-direction: column;\n  }\n\n  .adj-modal-footer button {\n    width: 100%;\n  }\n}\n\n/* ═══════════════════════════════════════════\n   DARK THEME — Stock Adjustment\n   ═══════════════════════════════════════════ */\n\n.dark .stock-adj-container {\n  background-color: #0f172a;\n}\n\n.dark .stock-adj-header {\n  background-color: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .stock-adj-back-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .stock-adj-back-btn:hover {\n  background-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .stock-adj-title {\n  color: #f1f5f9;\n}\n\n/* Search input */\n.dark .stock-adj-search-input {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n.dark .stock-adj-search-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n.dark .stock-adj-search-input::placeholder { color: #475569; }\n\n/* Filter button */\n.dark .stock-adj-btn-secondary {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .stock-adj-btn-secondary:hover { background-color: #334155; }\n.dark .stock-adj-btn-secondary svg { color: #94a3b8; }\n\n/* Active filter label */\n.dark .stock-adj-active-filters-label { color: #94a3b8; }\n\n/* Table card */\n.dark .stock-adj-table-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n/* Table header */\n.dark .stock-adj-table-card .stock-adj-table th {\n  background-color: #0f172a !important;\n  border-bottom-color: #334155 !important;\n  color: #94a3b8 !important;\n}\n\n/* Table rows */\n.dark .stock-adj-row {\n  border-bottom-color: #334155 !important;\n}\n.dark .stock-adj-row:hover { background-color: #243043; }\n\n/* Cell colours */\n.dark .stock-adj-cell-date { color: #94a3b8 !important; }\n.dark .stock-adj-item-name { color: #e2e8f0; }\n.dark .stock-adj-item-sku  { color: #64748b; }\n.dark .stock-adj-cell-reason { color: #94a3b8; }\n.dark .stock-adj-cell-auth  { color: #64748b; }\n.dark .stock-adj-item-date  { color: #64748b; }\n\n/* Dark-mode tags */\n.dark .tag-wastage    { background-color: #451a03 !important; color: #fbbf24 !important; border-color: #78350f !important; }\n.dark .tag-broken     { background-color: #4c0519 !important; color: #fca5a5 !important; border-color: #7f1d1d !important; }\n.dark .tag-correction-add { background-color: #052e16 !important; color: #6ee7b7 !important; border-color: #14532d !important; }\n\n/* Pagination */\n.dark .stock-adj-pagination {\n  background-color: #1e293b;\n  border-top-color: #334155;\n}\n.dark .stock-adj-pagination-info { color: #94a3b8; }\n.dark .stock-adj-pagination-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .stock-adj-pagination-btn:hover:not(:disabled) { background-color: #334155; }\n\n/* Loader / Empty */\n.dark .stock-adj-loader-container { background-color: #1e293b; }\n.dark .stock-adj-empty-state {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n/* ── Adjustment Creation Modal ── */\n.dark .adj-modal-container {\n  background-color: #1e293b;\n}\n\n.dark .adj-modal-title { color: #f1f5f9; }\n.dark .adj-modal-close-btn { color: #64748b; }\n.dark .adj-modal-close-btn:hover { color: #94a3b8; }\n\n.dark .adj-field-label { color: #94a3b8; }\n\n.dark .adj-field-input,\n.dark .adj-field-textarea {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n.dark .adj-field-input:focus,\n.dark .adj-field-textarea:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 1px #3b82f6;\n}\n.dark .adj-field-input::placeholder,\n.dark .adj-field-textarea::placeholder { color: #475569; }\n.dark .adj-field-input:disabled {\n  background-color: #1e293b !important;\n  color: #475569;\n  border-color: #334155 !important;\n}\n\n/* MUI Autocomplete inside modal */\n.dark .adj-field-group .MuiAutocomplete-root .MuiOutlinedInput-root {\n  background-color: #0f172a !important;\n  border-color: #334155 !important;\n}\n.dark .adj-field-group .MuiInputBase-input { color: #f1f5f9 !important; }\n\n.dark .adj-adjustment-item-card { background-color: #0f172a; }\n.dark .adj-adjustment-item-header { color: #f1f5f9; }\n\n.dark .adj-modal-footer {\n  background-color: #1e293b;\n  border-top-color: #334155;\n}\n.dark .adj-btn-cancel {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .adj-btn-cancel:hover { background-color: #334155; }\n\n.dark .adj-modal-content {\n  scrollbar-color: #334155 transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
